<template>
  <div>
    <div :class="[getTextSizeModal]" class="title-box new-box">
      <div
        class="md-layout-item md-size-20 review-title-header"
        v-if="!isModal"
      >
        <h6 class="title-selection">Name*</h6>
        <h6 v-if="checkTitleError()" class="alert-color review-page-adjust">Mandatory Field</h6>
      </div>
      <div v-else
        class="md-layout-item title-header"
      >
        <h6 class="title-selection">Title*</h6>
        <h6 v-if="checkTitleError()" class="alert-color">Mandatory Field</h6>
      </div>
      <div class="md-layout-item" :class="[getSizeModal]">
        <md-field class="input-container" :class="[{ 'empty-mandatory-field': checkTitleError() }]" ref="newItemTitle">
          <md-input
            v-model="title"
            @blur="storeDescription"
            data-cy="hpItemTitle"
          ></md-input>
        </md-field>
      </div>
    </div>
    <div :class="[getTextSizeModal]" class="description-box new-box">
      <div
        class="md-layout-item md-size-20 review-title-header"
        v-if="!isModal"
      >
        <h6 class="title-selection">Description*</h6>
        <h6 v-if="!this.itemDescription" class="alert-color review-page-adjust">Mandatory Field</h6>
      </div>
      <div v-else
        class="md-layout-item title-header"
      >
        <h6 class="title-selection">Description*</h6>
        <h6 v-if="checkDescriptionError()" class="alert-color">Mandatory Field</h6>
      </div>
      <div
        class="md-layout-item description-tooltip"
        :class="[getSizeModal]"
        data-toggle="tooltip"
        data-placement="bottom"
        :data-original-title="descriptionTooltip"
      >
        <md-field class="input-container fitting-adjustment" ref="newItemDescription">
          <vue-editor v-model="description" class="text-editor"
            :class="[{ 'empty-mandatory-field': checkDescriptionError()}]"
            @blur="storeDescription"
            data-cy="hpItemDescription-input"
            :editorToolbar="customToolbar"
            >
          </vue-editor>
        </md-field>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ItemHelperVue from "../../mixins/ItemHelper.vue";
import { VueEditor }  from "vue2-editor";

export default {
  name: "ReviewDescription",
  mixins: [ItemHelperVue],
  components: {
    VueEditor
  },
  props: ["isModal","hasError"],
  data() {
    return {
      title: null,
      description: null,
      maxTitle: 100,
      customToolbar: [
        ["bold", "italic", "underline", 'link'],
      ]
    };
  },
  watch: {
    itemTitle() {
      this.title = this.itemTitle;
    },
    itemDescription() {
      if (this.itemDescription !== null && this.itemDescription !== "") {
        this.description = this.itemDescription.replace(/<br>/g, "\n");
      }
    },
  },
  methods: {
    ...mapActions(["setNewItemDescription", "setNewItemTitle"]),
    storeDescription() {
      if (this.itemDescription !== this.description) {
        this.setNewItemDescription(this.description);
        this.storeItemSession();
      }
      if (this.itemTitle !== this.title) {
        this.setNewItemTitle(this.title);
        this.storeItemSession();
      }
    },
    checkTitleError() {
      if(this.isModal)
        return (this.hasError && !this.itemTitle);
      else
        return (!this.itemTitle);
    },
    checkDescriptionError() {
      if(this.isModal)
        return (this.hasError && !this.itemDescription);
      else
        return (!this.itemDescription);
    },
  },
  computed: {
    descriptionTooltip() {
      return `If you would like to lend or borrow something,
             please include the rental term in your description`;
      },
    ...mapGetters({
      itemTitle: "getNewItemTitle",
      itemDescription: "getNewItemDescription",
    }),
    getSizeModal() {
      if (this.isModal) {
        return "md-size-100 md-small-size-100 md-xsmall-size-100";
      } else {
        return "md-size-100 md-xsmall-size-100";
      }
    },
    getTextSizeModal() {
      if (this.isModal) {
        return "md-layout md-gutter description-box-content-modal";
      } else {
        return "md-layout md-gutter description-box-content";
      }
    },
  },
  mounted() {
    if (this.itemTitle || this.itemDescription) {
      this.description = this.itemDescription;
      this.title = this.itemTitle;
    }
    $(".description-tooltip").tooltip();
  },
};
</script>

<style scoped>
.title-box .md-field:after {
  height: 0;
}
.title-header {
  display: flex;
  min-width: 100%;
  justify-content: space-between;
}
.alert-color {
  color: red;
}
.empty-mandatory-field {
  border: 1px solid red !important;
}
.description-tooltip {
  width: 100%;
  font-size: 1em;
  align-content: center;
}

.title-box .md-field:before {
  height: 0px;
}

.md-input {
  padding: 2px 8px 13px 7px;
  width: 100%;
  height: 100%;
}

@media screen and (min-width: 1024px) {
  .description-box-content {
    flex-wrap: nowrap;
    align-items: center;
  }
}
@media screen and (min-width: 1025px) and (max-width: 1199px) {
  .description-box-content {
    margin-left: 44px;
  }
}
@media screen and (max-width: 1024px) {
  .description-box-content {
    margin-left: 0px;
  }
}
@media screen and (max-width: 600px) {
  .description-box-content {
    display: flex;
    flex-direction: column;
  }
  .review-title-header {
    display: flex;
    min-width: 100%;
    justify-content: space-between;
  }
}
</style>

<style lang="scss" scoped>
.fitting-adjustment {
  padding-top: 0px;
}
.new-box {
  display: flex;
  flex-direction: column;
  align-items: start;
}
.review-title-header {
  display: flex;
  min-width: 100%;
}
.review-page-adjust {
  margin-left: 10px;
}
.title-box .md-focused {
  border: 1px solid $primary !important;
}
.description-box .md-focused::before {
  border: 1px solid $primary !important;
  box-shadow: 0 !important;
}
.title-box .input-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  border: 1px solid #939393;
  box-sizing: border-box;
  border-radius: 4px;
  height: 3rem;
}
.title-selection {
  font-style: normal;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 1.25px;
  color: rgba(0, 0, 0, 0.9);
  font-size: 16px;
}
</style>

<style>
.md-count {
  bottom: -31px !important;
}
.md-field {
  min-height: 40px;
  display: block;
}
.tooltip .tooltip-inner {
  text-align: center;
  background-color: #767676;
  border-radius: 10px;
  font-size: 12px;
  max-width: 400px !important;
}
.tooltip.show {
  margin-top: -20px !important;
}
.ql-editor p {

  font-family: inherit;
  font-size: 16px;
  line-height: 32px;
  color: black !important;
}
.ql-snow .ql-formats {
  display: flex !important;
}
</style>

<style lang="scss" scoped>
.md-field.md-theme-swampum-primary.md-focused label {
  color: $primary !important;
}
label {
  font-size: 14px;
  margin-left: 11px;
  top: 15px;
}
.md-field.md-has-textarea:not(.md-autogrow) label {
  left: 0 !important;
}
</style>
